import braintree from 'braintree-web';
import Component from '../../Component';
import { STATUS } from '../../General';
//https://deepwiki.com/braintree/braintree-web/4.6-3d-secure-authentication
//https://codepen.io/braintree/pen/ezvymm
export default class BraintreeHostedFields extends Component {
    containerRef: any;
    constructor(props?: any) {
        super(props);
        this.state = {
            status: STATUS.LOADING,
            hostedFields: undefined,
            cardNumberValid: false,
            cvvValid: false,
            expirationDateValid: false,
        };
    }

    componentDidMount() {
        this.init();
    }

    init() {
        const subscriptionOrder = this.props.subscriptionOrder;
        const t = this.translate();
        let me = this;
        return this.setupBraintreeHostedFieldsAndTreeDSecure().then((instances) => {
            //            console.log(instances);
            let hf = instances[0];
            let threeDS = instances[1] as any;
            hf.on('blur', (event: any) => {
                //console.log(event.emittedBy, 'lost focus');
                let field = event.fields[event.emittedBy];
                let setSubmitState = () => {
                    if (this.state.cardNumberValid && this.state.expirationDateValid && this.state.cvvValid) {
                        (document.getElementById('submitCardInfoButton') as any).disabled = false;
                    }
                    else {
                        (document.getElementById('submitCardInfoButton') as any).disabled = true;
                    }
                }
                if (field.isValid) {
                    if (event.emittedBy === 'number') {
                        this.setState({ cardNumberValid: true }, setSubmitState);
                    }
                    if (event.emittedBy === 'expirationDate') {
                        this.setState({ expirationDateValid: true }, setSubmitState);
                    }
                    if (event.emittedBy === 'cvv') {
                        this.setState({ cvvValid: true }, setSubmitState);
                    }
                    //console.log(event.emittedBy, 'is fully valid');
                } else if (field.isPotentiallyValid) {
                    console.log(event.emittedBy, 'is potentially valid');
                    if (event.emittedBy === 'number') {
                        this.setState({ cardNumberValid: false }, setSubmitState);
                    }
                    if (event.emittedBy === 'expirationDate') {
                        this.setState({ expirationDateValid: false }, setSubmitState);
                    }
                    if (event.emittedBy === 'cvv') {
                        this.setState({ cvvValid: false }, setSubmitState);
                    }

                } else {
                    //console.log(event.emittedBy, 'is not valid');
                    if (event.emittedBy === 'number') {
                        this.setState({ cardNumberValid: false }, setSubmitState);
                    }
                    if (event.emittedBy === 'expirationDate') {
                        this.setState({ expirationDateValid: false }, setSubmitState);
                    }
                    if (event.emittedBy === 'cvv') {
                        this.setState({ cvvValid: false }, setSubmitState);
                    }
                }
            });
            hf.on('inputSubmitRequest', () => {
                // User requested submission, e.g. by pressing Enter or equivalent
                //  submitButton.click();
            });
            hf.on('validityChange', (event: any) => {
                let field = event.fields[event.emittedBy];
                let setSubmitState = () => {
                    if (this.state.cardNumberValid && this.state.expirationDateValid && this.state.cvvValid) {
                        (document.getElementById('submitCardInfoButton') as any).disabled = false;
                    }
                    else {
                        (document.getElementById('submitCardInfoButton') as any).disabled = true;
                    }
                }
                if (field.isValid) {
                    if (event.emittedBy === 'number') {
                        this.setState({ cardNumberValid: true }, setSubmitState);
                    }
                    if (event.emittedBy === 'expirationDate') {
                        this.setState({ expirationDateValid: true }, setSubmitState);
                    }
                    if (event.emittedBy === 'cvv') {
                        this.setState({ cvvValid: true }, setSubmitState);
                    }
                    //console.log(event.emittedBy, 'is fully valid');
                } else if (field.isPotentiallyValid) {
                    //console.log(event.emittedBy, 'is potentially valid');
                    if (event.emittedBy === 'number') {
                        this.setState({ cardNumberValid: false }, setSubmitState);
                    }
                    if (event.emittedBy === 'expirationDate') {
                        this.setState({ expirationDateValid: false }, setSubmitState);
                    }
                    if (event.emittedBy === 'cvv') {
                        this.setState({ cvvValid: false }, setSubmitState);
                    }
                } else {
                    //console.log(event.emittedBy, 'is not valid');
                    if (event.emittedBy === 'number') {
                        this.setState({ cardNumberValid: false }, setSubmitState);
                    }
                    if (event.emittedBy === 'expirationDate') {
                        this.setState({ expirationDateValid: false }, setSubmitState);
                    }
                    if (event.emittedBy === 'cvv') {
                        this.setState({ cvvValid: false }, setSubmitState);
                    }
                }
            });
            this.setState({ status: STATUS.READY }, () => {
                (document.getElementById('cardForm') as any).addEventListener("submit", (event: any) => {
                    event.preventDefault();
                    //console.log('submitCardInfoButton');
                    (document.getElementById('submitCardInfoButton') as any).disabled = true;

                    hf.tokenize().then((payload: any) => {
                        const amount = (+(subscriptionOrder.pricePerUser *
                            (subscriptionOrder.interval - subscriptionOrder.discountInterval) * subscriptionOrder.users).toFixed(2)
                            +
                            +(((+(subscriptionOrder.pricePerUser *
                                (subscriptionOrder.interval - subscriptionOrder.discountInterval) * subscriptionOrder.users).toFixed(2) *
                                (subscriptionOrder.vatEnabled && subscriptionOrder.vatRate ? (subscriptionOrder.vatRate / 100) : 0))).toFixed(2))).toFixed(2);
                        const email = subscriptionOrder.billingInformation.email.substring(0, 255);
                        const phone = subscriptionOrder.billingInformation.phone.replace(/[()\s-]/g, '').substring(0, 25);

                        //console.log(payload);
                        threeDS.on('lookup-complete', (data: any, next: any) => {
                            //console.log(payload);
                            //console.log('lookup-complete');
                            next();
                        });
                        threeDS.on('authentication-iframe-available', (event: any, next: any) => {
                            //console.log('authentication-iframe-available');
                            (document.getElementById("treeDSecureContainer") as any).appendChild(event.element); // add iframe element to page
                            (document.getElementById('cardForm') as any).classList.add('d-none');
                            next(); // let the SDK know the iframe is ready
                        });
                        threeDS.on('authentication-modal-close', () => {
                            //console.log('authentication-modal-close');
                            // the modal was closed
                        });
                        threeDS.on('customer-canceled', function () {
                            // the customer canceled the 3D Secure challenge
                            //console.log('customer-canceled');
                        });
                        threeDS.on('lookup-complete', function (data: any, next: any) {
                            // inspect the data
                            //console.log('lookup-complete');
                            //console.log(data);

                            // call next when ready to proceed with the challenge
                            next();
                        });
                        return threeDS.verifyCard({
                            nonce: payload.nonce,
                            bin: payload.details.bin,
                            amount: amount,
                            challengeRequested: true,
                            email: email,
                            phone: phone,
                            mobilePhoneNumber: phone,
                            billingAddress: {
                                givenName: subscriptionOrder.billingInformation.firstName.substring(0, 50),
                                surname: subscriptionOrder.billingInformation.lastName.substring(0, 50),
                                phoneNumber: phone,
                                streetAddress: subscriptionOrder.billingInformation.address ? subscriptionOrder.billingInformation.address.substring(0, 50) : '',
                                locality: subscriptionOrder.billingInformation.city.substring(0, 50),
                                postalCode: subscriptionOrder.billingInformation.postalCode.substring(0, 50),
                                countryCodeAlpha2: subscriptionOrder.billingInformation.country.substring(0, 2),
                            },
                            //https://braintree.github.io/braintree-web/current/ThreeDSecure.html#~additionalInformation
                            additionalInformation: {
                                workPhoneNumber: phone,
                            }
                        }, (err: any, response: any) => {
                            //console.log(response);
                            //console.log(err);
                            /*
                                                if (requestPaymentMethodErr) {
                                                    if (requestPaymentMethodErr?.message) {
                                                        this.errorToastr(requestPaymentMethodErr.message);
                                                        return;
                                                    }
                                                    this.generalErrorToastr();
                                                    return;
                                                }
                                                if (payload?.liabilityShiftPossible) {
                                                    if (!payload?.liabilityShifted) {
                                                        this.errorToastr(t('3dsecure.validation.failed'));
                                                        return;
                                                    }
                                                }
                            
                            */

                            //response.threeDSecureInfo;
                            if (!err) {
                                let liabilityShifted = response.liabilityShifted; // true || false
                                let liabilityShiftPossible = response.liabilityShiftPossible; // true || false
                                let threeDSecureAuthenticationId = response.threeDSecureInfo.threeDSecureAuthenticationId;
                                let cardLastFour = response.details.lastFour;
                                let cardExpiresOn = response.details.expirationMonth + '/' + response.details.expirationYear;
                                me.props.onValidationComplete({ liabilityShifted, liabilityShiftPossible, threeDSecureAuthenticationId, cardLastFour, cardExpiresOn });
                            } else {

                            }
                        })
                    })
                });
            })
        }).catch(function (err) {
            //console.log('component error:', err);
            me.errorToastr(t('a.general.an.error.occurred'));
        });
    }

    setupBraintreeHostedFieldsAndTreeDSecure() {
        return Promise.all([braintree.hostedFields.create({
            authorization: this.props.braintreeSettings.client_token,
            styles: {
                ':focus': {
                    'color': 'black'
                },
                '.valid': {
                    'color': 'green'
                },
                '.invalid': {
                    'color': 'red'
                }
            },
            fields: {
                number: {
                    selector: '#card-number',
                    placeholder: '1111 1111 1111 1111'
                },
                cvv: {
                    selector: '#cvv',
                    placeholder: '111'
                },
                expirationDate: {
                    selector: '#expiration-date',
                    placeholder: 'MM/YY'
                },
            }
        }),
        braintree.threeDSecure.create({
            authorization: this.props.braintreeSettings.client_token,
            version: '2-inline-iframe'
        })
        ]);
    }

    render() {
        const t = this.translate();
        return <div>
            {this.state.status === STATUS.LOADING ?
                this.renderLoading() : null}
            <div className={this.state.status === STATUS.READY ? '' : 'd-none'}>
                <div ref={ref => (this.containerRef = ref)} >
                    <form id="cardForm">
                        <fieldset>
                            <div className="row">
                                <div className="col-12 mb-3 mt-3">
                                    <div className="textfield--float-label">
                                        <label className="hosted-field--label" htmlFor="card-number">
                                            <i className="far fa-credit-card" /> {t('card.number')}
                                        </label>
                                        <div id="card-number" className="hosted-field"></div>
                                    </div>
                                </div>
                                <div className="col-6 mb-3">
                                    <div className="textfield--float-label">
                                        <label className="hosted-field--label" htmlFor="expiration-date">
                                            <i className="far fa-calendar" /> {t('expiration:date')}</label>
                                        <div id="expiration-date" className="hosted-field"></div>
                                    </div>
                                </div>
                                <div className="col-6 mb-3">
                                    <div className="textfield--float-label">
                                        <label className="hosted-field--label" htmlFor="cvv">
                                            <i className="fas fa-lock" /> {t('cvv')}</label>
                                        <div id="cvv" className="hosted-field"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <button id="submitCardInfoButton"
                                        type={'submit'}
                                        disabled={true}
                                        className={'btn btn-block btn-primary'}
                                    >
                                        {t('use.card')}
                                    </button>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                    <div id="treeDSecureContainer">
                        <div className="row">
                            <div className="col-12 mb-3 mt-3">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}
